export const minWidth = breakpoint => {
  return `screen and (min-width: ${breakpoint}px)`;
};
export const maxWidth = breakpoint => {
  return `screen and (max-width: ${breakpoint}px)`;
};
export const range = (breakpoint1, breakpoint2) => {
  return `screen and (min-width: ${breakpoint1}px) and (max-width: ${breakpoint2}px)`;
};